

import { defineComponent,PropType,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';
import {UserService} from "@/services/user.service";
import {useStore} from "vuex";
import {Usuario} from "@/models/user.interface";

  export default defineComponent({
   name: "SideBar",
   setup(){
      let userService = new UserService();
      let user:Usuario = userService.fetch();
      let mostrarMenu:Ref<Boolean> = ref(false);

      const usuario = userService.fetch();
      

    onMounted(()=>{
      if (!usuario.profiles.includes("uploader")){
         mostrarMenu.value=true;
      }
    });

     const imgUser = (picture)=>{
	let img = "";
	switch(picture){
	  case "":
	    img = require("@/img/avatar-1.png");
	    break;
	  default:
	    img = (picture);
	    break;
	}
	return img;
	  
      };

     return {user,imgUser,mostrarMenu} 
   }
  })
